import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAllPpeMaster = (data) => {
  return axios.get(`${apiurl?.getAllPpeMaster}?searchCriteria=${data?.searchCriteria}&Page=${data?.Page}&PageSize=${data?.PageSize}&isAll=${data?.isAll}&vesselGroupId=${data?.vesselGroupId} `);
};

const getAllPpeMaster = (data) => {
  return useQuery(['getAllPpeMaster', data], () => fetchAllPpeMaster(data), { refetchOnWindowFocus: false });
};

export default getAllPpeMaster;
